module.exports = __webpack_public_path__ + "img/MapPicsTeutoburgForest.db7c46c4.webp";